import React from 'react';
import PropTypes from 'prop-types';
import { ANIMATION_PERCENTAGE } from '../../constants/parallax';
import cn from 'classnames';

const ParallaxTextPanel = ({
  textBackgroundColor = '#EAF4FA',
  textColor = '#001E64',
  percentage,
  textAnimationPercentage = ANIMATION_PERCENTAGE.text,
  className,
  children,
}) => {
  return children ? (
    <div
      className={cn('parallax-text-panel', className)}
      style={{
        backgroundColor: textBackgroundColor,
        color:
          percentage <= textAnimationPercentage
            ? textBackgroundColor
            : textColor,
        transition:
          percentage <= textAnimationPercentage
            ? 'left 500ms ease-out 350ms, color 500ms ease-out 0ms'
            : 'left 500ms ease-in 0ms, color 500ms ease-out 500ms',
        position: 'relative',
        bottom: 0,
        left: percentage > textAnimationPercentage ? '0%' : '-120%',
      }}
    >
      <div
        role="presentation"
        className="parallax-text-panel__overlay"
        style={{
          backgroundColor: textColor,
          top: percentage > textAnimationPercentage ? '-100%' : 0,
          transition:
            percentage > textAnimationPercentage
              ? 'top 500ms ease-out 500ms'
              : 'top 500ms ease-out 0ms',
        }}
      ></div>
      {children}
    </div>
  ) : null;
};

ParallaxTextPanel.viewModelMeta = 'ignore';

ParallaxTextPanel.propTypes = {
  textBackgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  percentage: PropTypes.number.isRequired,
  textAnimationPercentage: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
};

export default ParallaxTextPanel;
